import R from "ramda";
import { http } from "./http";

export const fetchVendors = (accountId) => (
  http.get(`/accounts/${accountId}/vendors`)
    .then(response => {
      const vendors = R.pathOr([], ["data", "vendors"], response);
      return { response, vendors };
    })
);



// WEBPACK FOOTER //
// ./src/js/api/vendors.js